import { useEffect, useMemo, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchCategories } from '@/store/slices/categories';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { getCategories } from '@/store/slices/categories/selectors';

type TUseLoadCategories = {
  skipIfCategoriesExist?: boolean;
};

const useLoadCategories = (props?: TUseLoadCategories) => {
  const { skipIfCategoriesExist } = props || {};

  const channel = useAppSelector(getActiveChannel);
  const categories = useAppSelector(getCategories);

  const dispatch = useAppDispatch();

  const fetched = useRef(false);

  const shouldReturnEarly = useMemo(() => {
    return skipIfCategoriesExist && categories;
  }, [skipIfCategoriesExist, categories]);

  useEffect(() => {
    if (!channel || fetched.current || shouldReturnEarly) {
      return;
    }
    fetched.current = true;
    dispatch(fetchCategories({ channel, returnStoreStateIfExists: true }));
  }, [channel, dispatch, shouldReturnEarly]);
};

export default useLoadCategories;
